/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ClaimInformationMandatoryFieldsEnum {
    PARTNER = 'Partner',
    PLANT = 'Supplying Packing Plant',
    CLAIM_CODE = 'Claim Code',
    MATERIAL = 'Material'
}
